import { useGcsStore } from '../../../store/useGcsStore';
import type { VehicleId } from '../../../types/gcs/vehicle';
import {
  getVehicleStatusLabel,
  getVehicleStatusBackgroundColor,
  getVehicleStatusForegroundColor
} from '../../../types/ui/vehicleStatus';
import { getVehicleStatusCategory } from '../../../types/ui/vehicleStatusCategory';
import { selectVehicleStatus } from '../../../store/selectors/selectVehicleStatus';
import { Text } from '../../../components/general/Text';

interface VehicleStatusTileProps {
  gcsId: string;
  vehicleId: VehicleId;
}

function VehicleStatusTile({ gcsId, vehicleId }: VehicleStatusTileProps) {
  const vehicleStatus = useGcsStore((state) => selectVehicleStatus(state.data, gcsId, vehicleId));

  if (!vehicleStatus) return null;

  const label = getVehicleStatusLabel(vehicleStatus);
  const category = getVehicleStatusCategory(vehicleStatus);
  const backgroundColor = getVehicleStatusBackgroundColor(category);
  const foregroundColor = getVehicleStatusForegroundColor(category);

  return (
    <Text
      variant='body3-bold'
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '16px',
        color: foregroundColor,
        backgroundColor: backgroundColor,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        minWidth: 0,
        maxWidth: '100%'
      }}
    >
      {label}
    </Text>
  );
}

export default VehicleStatusTile;
